import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import MobileCTA from "@/components/MobileCTA";
import CookieConsent from "@/components/CookieConsent";
import { pushEvent } from "@/lib/tracking";

export default function Layout() {
  // Global click delegation for tracking phone/email/CTA clicks.
  useEffect(() => {
    const handler = (e) => {
      const a = e.target.closest && e.target.closest("a");
      if (!a) return;
      const href = a.getAttribute("href") || "";
      if (href.startsWith("tel:")) {
        pushEvent("phone_click", { link_url: href, link_text: (a.textContent || "").trim() });
      } else if (href.startsWith("mailto:")) {
        pushEvent("email_click", { link_url: href, link_text: (a.textContent || "").trim() });
      } else if (a.dataset && a.dataset.track === "cta_click") {
        pushEvent("cta_click", { cta_label: (a.textContent || "").trim(), link_url: href });
      }
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:bg-foreground focus:text-background focus:px-4 focus:py-2 focus:text-sm">
        Gå direkte til indhold
      </a>
      <Nav />
      <main id="main" tabIndex="-1">
        <Outlet />
      </main>
      <Footer />
      <MobileCTA />
      <CookieConsent />
    </div>
  );
}
